exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nSex22jJhxuH_NoJLuWL4{color:\"[theme:themeDark, default:#0D62AA]\";font-weight:600}html[dir=ltr] .nSex22jJhxuH_NoJLuWL4{padding-left:5px}html[dir=rtl] .nSex22jJhxuH_NoJLuWL4{padding-right:5px}", ""]);
// Exports
exports.locals = {
	"unreadCount": "nSex22jJhxuH_NoJLuWL4"
};